import { DataTableColumn } from "../../data-table.config";

export class DataTableColumnIcon extends DataTableColumn {
    value!: (item: any) => string;

    constructor(params : any)
    {
        super();
        Object.assign(this, params);
    }
}
